import { render, staticRenderFns } from "./mixn.vue?vue&type=template&id=2a6efd0e"
import script from "./mixn.vue?vue&type=script&lang=js"
export * from "./mixn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports